import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { SocketServiceService } from '../socket-service/socket-service.service';
import { AuthServiceService } from '../auth-service/auth-service.service';
import { OrderEngineServiceService } from '../order-engien-service/order-engine-service.service';
import { NgTemplateOutlet } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DataSharingService {
  private isBrowser = false;
  lastFuturesData: any = null;
  lastOptionsData: any = null;
  lastMarketData: any = null;
  pnlSocketService: any;
  // Create a private BehaviorSubject with an initial value
  private sliderVisible = new BehaviorSubject<boolean>(false);
  // Observable that components can subscribe to
  sliderData$ = this.sliderVisible.asObservable();
  dataShareConnected: boolean = false;
  //future observable
  private selectedFutureData = new Subject<any>();
  futureData$ = this.selectedFutureData.asObservable();

  private sideNav = new BehaviorSubject<string>('');
  sideNav$ = this.sideNav.asObservable();
  // Method to send new data to the subject

  private selectedPairStream = new BehaviorSubject<any>({});
  selectedPairStream$ = this.selectedPairStream.asObservable();

  private ordersStream = new BehaviorSubject<any>({});
  ordersStream$ = this.ordersStream.asObservable();

  private accountDetailsStream = new BehaviorSubject<any>({});
  accountDetailsStream$ = this.accountDetailsStream.asObservable();

  private marketData = new BehaviorSubject<any>(null);
  marketData$ = this.marketData.asObservable();

  private futuresData = new BehaviorSubject<any>(null);
  futuresData$ = this.futuresData.asObservable();

  private optionsData = new BehaviorSubject<any>(null);
  optionsData$ = this.optionsData.asObservable();

  private pnlData = new BehaviorSubject<any>({}); //new Subject<any>();
  pnlData$ = this.pnlData.asObservable();

  private accountDetails = new BehaviorSubject<any>({});
  accountDetails$ = this.accountDetails.asObservable();

  private hideShowList = new BehaviorSubject<any>({});
  hideShowList$ = this.hideShowList.asObservable();

  private accountTabType = new BehaviorSubject<any>({});
  accountTabType$ = this.accountTabType.asObservable();

  private screenResolutionChange = new BehaviorSubject<any>({});
  screenResolutionChange$ = this.screenResolutionChange.asObservable();

  private orderBookSend = new BehaviorSubject<any>({});
  orderBookSend$ = this.orderBookSend.asObservable();

  private selectedContractChart = new Subject<any>();
  selectedContractChart$ = this.selectedContractChart.asObservable();

  private removeAllOrders = new Subject<any>();
  removeAllOrders$ = this.removeAllOrders.asObservable();

  private orderBookUpdate = new BehaviorSubject<any>({});
  orderBookUpdate$ = this.orderBookUpdate.asObservable();

  private reloadChartOnNavigate = new BehaviorSubject<any>({});
  reloadChartOnNavigate$ = this.reloadChartOnNavigate.asObservable();

  private mobileBottomNavigation = new BehaviorSubject<any>('');
  mobileBottomNavigation$ = this.mobileBottomNavigation.asObservable();

  constructor(
    private socketService: SocketServiceService,
    @Inject(PLATFORM_ID) platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      let token = localStorage.getItem('token'); // Retrieve token from localStorage
      if (token) {
        this.socketService.connect(token);
      } else {
        this.socketService.connect('');
      }
      if (this.socketService.getSocketIntance()) {
        this.connectDataSharing();
      }
      this.checkScreenSize();
      this.listenForResize();
    }
  }

  private checkScreenSize(): void {
    if (this.isBrowser) {
      const width = window.innerWidth;
      let sizeCategory = '';

      if (width <= 768) {
        sizeCategory = 'mobile';
      } else if (width <= 1024) {
        sizeCategory = 'small_laptop';
      } else if (width <= 1440) {
        sizeCategory = 'large_laptop';
      } else {
        sizeCategory = 'large_screen';
      }
      this.screenResolutionChange.next(sizeCategory);
    }
  }

  private listenForResize(): void {
    if (this.isBrowser) {
      window.addEventListener('resize', () => this.checkScreenSize());
    }
  }

  initSocketOnReload() {
    console.log('Page reloaded, reinitializing socket connection... 1');

    const nav = performance.getEntriesByType(
      'navigation',
    )[0] as PerformanceNavigationTiming;

    if (nav?.type === 'reload') {
      console.log('Page reloaded, reinitializing socket connection...');
      this.socketService.emit('switchStream', ['all']);
    }
  }

  connectDataSharing() {
    if (this.socketService.getSocketIntance()) {
      this.socketService.listen('market-data').subscribe((_data: any) => {
        this.sendMarketData(_data);
        if (_data && _data.marketData) {
          this.lastMarketData = _data;
        }
      });
      this.socketService.listen('orderBookUpdate').subscribe((_data: any) => {
        this.sendOrderBookData(_data);
      });
      this.socketService.listen('futures-data').subscribe((_data: any) => {
        this.sendFuturesData(_data);
        if (_data && _data.futuresData && _data.futuresData.length) {
          this.lastFuturesData = _data;
        }
      });
      this.socketService.listen('optionsData').subscribe((_data: any) => {
        this.sendOptionsData(_data);
        if (_data && _data.optionsData) {
          this.lastOptionsData = _data;
        }
      });
      this.pnlSocketService = this.socketService
        .listen('pnl')
        .subscribe((_data: any) => {
          // console.log('Received PnL data:', _data);
          this.sendPnlData(_data);
        });
      this.socketService.listen('update-balance').subscribe((_data: any) => {
        this.sendAccountDetails(_data);
      });
    }
  }

  sendOrderBookData(data: any) {
    this.orderBookUpdate.next(data);
  }
  sendData(data: any) {
    this.sliderVisible.next(data);
  }
  sendSelectedFuture(data: any) {
    this.selectedFutureData.next(data);
  }
  sendSelectedNav(data: string) {
    this.sideNav.next(data);
  }
  sendSelectedPairStream(data: any) {
    this.selectedPairStream.next(data);
  }
  sendOrdersStream(data: any) {
    this.ordersStream.next(data);
  }
  sendAccountStream(data: any) {
    this.accountDetailsStream.next(data);
  }
  sendMarketData(data: any) {
    this.marketData.next(data);
  }
  sendFuturesData(data: any) {
    this.futuresData.next(data);
  }
  sendOptionsData(data: any) {
    this.optionsData.next(data);
  }
  sendPnlData(data: any) {
    this.pnlData.next(data);
  }
  sendAccountDetails(data: any) {
    this.accountDetails.next(data);
  }

  hideShowListFunc(data: any) {
    this.hideShowList.next(data);
  }

  sendAccountTabType(data: any) {
    this.accountTabType.next(data);
  }

  sendSelectedContractChart(data: any) {
    this.selectedContractChart.next(data);
  }

  sendRemoveOrdersEvent(data: any) {
    this.removeAllOrders.next(data);
  }

  onReloadChart(data: any) {
    this.reloadChartOnNavigate.next(data);
  }

  onMobileNavigationChange(data: any) {
    this.mobileBottomNavigation.next(data);
  }

  resetPnl() {
    // this.pnlData = new Subject<any>();
    // this.pnlData$ = this.pnlData.asObservable();
    // this.pnlData.complete();
  }

  //Socket listening
}
